import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { StatsChartData } from '../statsTypes';

const DEFAULT_COLORS = ['#1976D2', '#2E7D32', '#F57C00', '#C62828', '#7B1FA2', '#00838F'];

interface StatsPieChartProps {
  data: StatsChartData[];
  title: string;
}

const StatsPieChart: React.FC<StatsPieChartProps> = ({ data, title }) => {
  const hasData = data.length > 0 && data.some(d => d.value > 0);

  return (
    <div className="stats-chart">
      <h4 className="stats-chart__title">{title}</h4>
      {!hasData ? (
        <p className="stats-chart__empty">No data to display</p>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={90}
              dataKey="value"
              nameKey="name"
              label={({ percent }: { percent?: number }) => `${((percent ?? 0) * 100).toFixed(0)}%`}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color || DEFAULT_COLORS[index % DEFAULT_COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default StatsPieChart;
